module.exports = __webpack_public_path__ + "8f657c9d.png";